import '../style/Pagination.scss';


const Pagination = ({ page, totalPages, batchId, handleProtectedNavigate, navigate }) => {
  // Handler for the "Previous" button
  const goToPreviousPage = (e) => {
    e.stopPropagation();
    if (page > 1) {
      handleProtectedNavigate(() => navigate(`/traductor?batchId=${batchId}&page=${page - 1}`));
    }
  };

  // Handler for the "Next" button
  const goToNextPage = (e) => {
    e.stopPropagation();
    if (page < totalPages) {
      handleProtectedNavigate(() => navigate(`/traductor?batchId=${batchId}&page=${page + 1}`));
    }
  };

  // Don't render anything if there's only 1 page or pages are unknown
  if (totalPages <= 1) {
    return null; 
  }

  return (
    <div className="pagination-container">
      <button
        className='pagination-arrow'
        disabled={page <= 1}
        onClick={goToPreviousPage}
        aria-label="Previous Page"
      >
        &lt;
      </button>

      <div className="pagination-number">
        {page} / {totalPages}
      </div>

      <button
        className='pagination-arrow'
        disabled={page >= totalPages}
        onClick={goToNextPage}
        aria-label="Next Page"
      >
        &gt;
      </button>
    </div>
  );
};

export default Pagination;